import React, { useEffect, useState, useRef } from "react";
import styles from "./Home.module.css";
import mainImage from "../../assets/images/mainImage.png";
import HomeBottom from "./HomeBottom";
import logohome from "../../assets/images/logohome.svg";
import Select, { components } from "react-select";
import { AiFillCaretDown } from "react-icons/ai";
import HomeSecond from "./HomeSecond";
import HomeThird from "./HomeThird";
import HomeFour from "./HomeFour";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { HiMenuAlt3 } from "react-icons/hi";
import logo from "../../assets/images/logo.svg";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import changeLogin from "../../store/Actions/LoginAction";
import changeSelectedType from '../../store/Actions/SelectedTypeAction'
import { countriesApi } from "../../config/countriesApi";
import {countryApi} from '../../config/countryApi'

const options2 = [
  { value: "Tourist Visa", label: "Tourist Visa" },
  { value: "Work Visa", label: "Work Visa" },
  { value: "Study Visa", label: "Study Visa" },
  { value: "Permanent resident", label: "Permanent resident" },
];

function Home(props) {
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(true);
  const [options1, setOptions1] = useState([{ label: "Loading...", isDisabled: true}]);
  const [options2, setOptions2] = useState([
    { label: "Select Destination First...", isDisabled: true },
  ]);
  const [country, setCountry] = useState(null);

  const opt2 = useRef();


  useEffect(() => {
    const countries = async () => {
      const countries = await countriesApi();

      if (countries.data) {
        const cont = await countries.data.data;
        setData(countries.data.data);
        setLoader(false);
        setOptions1([]);
        setOptions1([
          {
            value: "Popular Countries",
            label: "Popular Countries",
            isDisabled: true,
          },
        ]);
        cont.map((value) => {
          setOptions1((options1) => [
            ...options1,
            {
              value: value.display_name,
              label: (
                <span
                  dangerouslySetInnerHTML={{
                    __html: `<b>${value.code}</b> &nbsp; &nbsp; &nbsp; ${value.display_name}`,
                  }}
                />
              ),
            },
          ]);
        });
      } else if (countries.error) {
        console.log(countries.error);
        setLoader(false);
      }
    };
    countries();
  }, []);

  const handleDestination = async (e) => {
    setCountry(e.value)
    const country = await countryApi(e.value);
    if (country.data) {
      setOptions2([]);
      opt2.current.select.clearValue();

      const cont = await country.data.data;
      if (cont.visa_packages.length !== 0) {
        cont.visa_packages.map((value) => {
          setOptions2((options2) => [
            ...options2,
            { value: value.name, label: value.name, id: value._id },
          ]);
        });
      } else {
        setOptions2([]);
      }
    } else if (country.error) {
      setOptions2([]);
    }
  };

  const handleVisaType = (e) => {
    props.ChangeSelectedType(e)
  }


  useEffect(()=>{
    props.ChangeSelectedType(null)
  },[])

  const style1 = {
    control: (base) => ({
      ...base,
      border: "0 !important",
      boxShadow: "0 !important",
      fontSize: "16px",
      fontFamily: "Montserra",
      fontWeight: 400,
      lineHeight: "20px",
      cursor: "pointer",
      "&:hover": {
        border: "0 !important",
      },
    }),
    menu: (base) => ({
      ...base,
      marginTop: 30,
      fontSize: 16,
      maxWidth: 341,
    }),
    dropdownIndicator: (defaultStyles) => ({
      ...defaultStyles,
      color: "#7FA2B6",
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      transform: state.selectProps.menuIsOpen && "rotate(180deg)",
      color: "#7FA2B6",
      "&:hover": {
        color: "#7FA2B6",
      },
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isDisabled ? "#ffffff" : isFocused ? "#E7E7E7" : null,
        color: "#164550",
        cursor: isDisabled ? "not-allowed" : "default",
        fontSize: "18px",
        fontFamily: "Roboto",
      };
    },
  };

  const DropdownIndicator = (
    props: ElementConfig<typeof components.DropdownIndicator>
  ) => {
    return (
      <components.DropdownIndicator {...props}>
        <AiFillCaretDown size={20} />
      </components.DropdownIndicator>
    );
  };

  const login = props.login;

  const logout = () => {
    localStorage.removeItem("userData");
    props.ChangeLogin(false);
  };

  useEffect(() => {
    function getWithExpiry(key) {
      const itemStr = localStorage.getItem(key);

      // if the item doesn't exist, return null
      if (!itemStr) {
        return null;
      }

      const item = JSON.parse(itemStr);
      const now = new Date();

      if (now.getTime() > item.expiry) {
        localStorage.removeItem(key);
        console.log("REMOVE");
        return null;
      }

      props.ChangeLogin(true);
      return item.value;
    }

    getWithExpiry("userData");

    document.title = "VisaPro";
  }, []);
  return (
    <div>
      <div className={styles.main}>
        <div className={styles.navbar}>
          <Link to="/">
            <img className={styles.logohome} src={logohome} alt="Logo" />
          </Link>
          <div className={styles.navopt}>
            <Link to="/">
              <p className={styles.text}>Home</p>
            </Link>
            <p className={styles.text}>Contact us</p>
            <p className={styles.text}>FAQ's</p>
            {login ? (
              <Link to="/dashboard/home">
                <button className={styles.login}>My Account</button>
              </Link>
            ) : (
              <Link to="/login">
                <button className={styles.login}>Login</button>
              </Link>
            )}
          </div>
        </div>
        <div className={styles.center}>
          <h1 className={styles.heading}>The world is yours to explore</h1>

          <div className={styles.back}>
            <div className={styles.countrySelect}>
              <Select
                styles={style1}
                className={styles.inners}
                isSearchable={false}
                options={options1}
                placeholder={"Select Country"}
                components={{
                  IndicatorSeparator: () => null,
                  DropdownIndicator,
                }}
                onChange={(e)=>{handleDestination(e)}}
                theme={(theme) => ({
                  ...theme,
                  colors: {
                    ...theme.colors,
                    neutral50: "#7FA2B6",
                  },
                })}
              />
            </div>

            <div className={styles.countrySelect}>
              <Select
                styles={style1}
                className={styles.inners}
                isSearchable={false}
                options={options2}
                ref={opt2}
                placeholder={"Choose Visa Type"}
                components={{
                  IndicatorSeparator: () => null,
                  DropdownIndicator,
                }}
                onChange={(e)=>{handleVisaType(e)}}
                theme={(theme) => ({
                  ...theme,
                  colors: {
                    ...theme.colors,
                    neutral50: "#7FA2B6",
                  },
                })}
              />
            </div>
            {(country !== null) ? (
              <Link to={`/countries/${country}`}>
                <button className={styles.started}>Get Started</button>
              </Link>
            ) : (
              <button className={styles.started}>Get Started</button>
            )}
          </div>
        </div>
      </div>

      <MobileHome
        login={login}
        ChangeLogin={props.ChangeLogin}
        data={data}
        loader={loader}
      />
      <HomeSecond />
      <HomeThird />
      <HomeFour />
      <HomeBottom />
    </div>
  );
}

const useStyles = makeStyles({
  list: {
    width: 250,
  },
  fullList: {
    width: "auto",
  },
});

function MobileHome(props) {
  const login = props.login;

  const classes = useStyles();
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <div className={clsx(classes.list)} role="presentation">
      <List>
        <div className={styles.navopt}>
          <Link
            to="/"
            className={styles.text}
            onClick={toggleDrawer(anchor, false)}
          >
            <span>Home</span>
          </Link>
          <p className={styles.text}>Contact us</p>
          <p className={styles.text}>FAQ's</p>
          {login ? (
            <Link to="/dashboard/home">
              <button className={styles.login}>My Account</button>
            </Link>
          ) : (
            <Link to="/login">
              <button className={styles.login}>Login</button>
            </Link>
          )}
        </div>
      </List>
    </div>
  );

  useEffect(() => {
    function getWithExpiry(key) {
      const itemStr = localStorage.getItem(key);

      if (!itemStr) {
        return null;
      }

      const item = JSON.parse(itemStr);
      const now = new Date();

      if (now.getTime() > item.expiry) {
        localStorage.removeItem(key);
        return null;
      }

      props.ChangeLogin(true);
      console.log(item.value)

      return item.value;
    }

    getWithExpiry("userData");

    document.title = "VisaPro";
  }, []);

  return (
    <div className={styles.nav}>
      <Link to="/">
          <img src={logo} alt="Logo" className={styles.logoa} />
        </Link>
      {["left"].map((anchor) => (
        <React.Fragment key={anchor}>
          <Button
            onClick={toggleDrawer("left", true)}
            style={{ outline: "none" }}
          >
            <HiMenuAlt3 className={styles.burger} />
          </Button>
          <Drawer
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer("left", false)}
          >
            {list(anchor)}
          </Drawer>
        </React.Fragment>
      ))}
    </div>
  );
}

const mapStateToProps = (state) => ({
  login: state.Login.login,
  selectedType: state.SelectedType.selectedType,
});

const mapDispatchToProp = (dispatch) => ({
  ChangeLogin: (login) => dispatch(changeLogin(login)),
  ChangeSelectedType: (selectedType) => dispatch(changeSelectedType(selectedType)),
});

export default connect(mapStateToProps, mapDispatchToProp)(Home);
